const { APIPost } = require('utilities/APIRequestHelper');
const { getECardInformation } = require('actions/eCardInformation');
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const actionTypes = require('constants/actionTypes');
const { toFirstUppercase } = require('utilities/stringHelper');
const { getEndDateForCardCharge } = require('utilities/cardsHelper');
const moment = require('moment');
const {
    CARD_CHARGE_OPERATION_CHARGE,
    CARD_OPENYOUNG,
    DATE_FORMAT_API,
    PERIODICITY_BIANNUAL,
    PERIODICITY_CONSTANTLY,
    PERIODICITY_DATE,
    DATE_FOR_INFINITE,
    PERIODICITY_HALF_YEARLY
} = require('constants/index');

const setAmount = amount => ({
    type: actionTypes.CARD_CHARGE_AMOUNT,
    payload: {
        amount
    }
});

const setView = view => ({
    type: actionTypes.CARD_CHARGE_VIEW,
    payload: {
        view
    }
});

const setOperationType = operationType => ({
    type: actionTypes.CARD_CHARGE_OPERATION_TYPE,
    payload: {
        operationType
    }
});

const setAccount = (accountId) => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const accountAvailableBalance = accountId ? immAccount.getIn(['balances', 'availableBalance', 'amount']) : null

    dispatch({
        type: actionTypes.CARD_CHARGE_ACCOUNT,
        payload: {
            accountId,
            accountAvailableBalance
        }
    });
};

const setVisibleStep = step => ({
    type: actionTypes.CARD_CHARGE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});


const setWillCancel = willCancel => ({
    type: actionTypes.CARD_CHARGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const handlePeriodicityType = type => ({
    type: actionTypes.CARD_CHARGE_SET_PERIODICITY_TYPE,
    payload: {
        type
    }
});

const handlePeriodicityDate = date => ({
    type: actionTypes.CARD_CHARGE_SET_PERIODICITY_DATE,
    payload: {
        date
    }
});

const handlePeriodicityCount = (count, date) => ({
    type: actionTypes.CARD_CHARGE_SET_PERIODICITY_COUNT,
    payload: {
        count,
        estimatedDate: date
    }
});

const handlePeriodicityRange = range => ({
    type: actionTypes.CARD_CHARGE_SET_PERIODICITY_RANGE,
    payload: {
        range
    }
});

const setDate = date => ({
    type: actionTypes.CARD_CHARGE_DATE,
    payload: {
        date
    }
});

const setTodayDate = date => ({
    type: actionTypes.CARD_CHARGE_TODAY_DATE,
    payload: {
        date
    }
});

const handlePeriodicityEnabled = flag => ({
    type: actionTypes.CARD_CHARGE_SET_PERIODICITY_ENABLED,
    payload: {
        enabled: flag
    }
});

const setPeriodicityConcept = value => ({
  type: actionTypes.CARD_CHARGE_SET_PERIODICITY_CONCEPT,
  payload: {
      periodicityConcept: value,
      periodicityConceptDirty: false
  }
});

const checkIfEmptyConcept = value =>  {
  let error = false
  if(value.length === 0) {
    error = true
  }
  return error
}

const handlePeriodicityConcept = (value) => (dispatch) => {
    const periodicityConceptDirty = checkIfEmptyConcept(value)
    dispatch({
      type: actionTypes.CARD_CHARGE_SET_PERIODICITY_CONCEPT,
      payload: {
          periodicityConcept: value,
          periodicityConceptDirty: periodicityConceptDirty
      }
    });
};

const withdrawTotalAmount = checked => ({
    type: actionTypes.CARD_WITHDRAW_TOTAL_AMOUNT,
    payload: {
        checked
    }
});

const clearRequest = () => ({ type: actionTypes.CARD_CHARGE_CLEAR });

const confirmationRequest = () => ({ type: actionTypes.CARD_CHARGE_CONFIRMATION_REQUEST });

const confirmationSuccess = () => ({ type: actionTypes.CARD_CHARGE_CONFIRMATION_SUCCESS });

const confirmationFailure = error => ({
    type: actionTypes.CARD_CHARGE_CONFIRMATION_FAILURE,
    payload: { error }
});

const validateUIStep = step => ({
    type: actionTypes.CARD_CHARGE_VALIDATE_UI_STEP,
    payload: { step }
});

const validationRequest = () => ({ type: actionTypes.CARD_CHARGE_VALIDATION_REQUEST });

const validationSuccess = data => ({
    type: actionTypes.CARD_CHARGE_VALIDATION_SUCCESS,
    payload: {
        liquidationData: data.datosPreliq || {}
    }
});

const validationFailure = (data) => ({
    type: actionTypes.CARD_CHARGE_VALIDATION_FAILURE,
    payload: {
        error: data.errorDescription
    }
});

const editCardChargeStep1 = (data) => ({
    type: actionTypes.CARD_CHARGE_EDIT_STEP1,
    payload: {
        data
    }
});

const setAllAccountsToInactive = () =>({
    type: actionTypes.CARD_CHARGE_SET_ALL_ACCOUNTS_TO_INACTIVE
});

const baseRequestData = (getState, cardId, accountId) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immECardInfo = immCard.getIn(['extra', 'eCardInfo']);

    const requestData = {
        query: {
            contratoTarjeta: {
                numerodecontrato: immCard.getIn(['contract', 'number']),
                producto: immCard.getIn(['contract', 'product'])
            },
            cuentaAsociada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            numTarjeta: immCard.get('number'),
            datosTarjeta: {
                saldoActualPrepago: {
                    divisa: immECardInfo.getIn(['saldoActualPrepago', 'divisa'])  || immCard.getIn(['availableBalance', 'currency']),
                    importe: immECardInfo.getIn(['saldoActualPrepago', 'importe']) || immCard.getIn(['availableBalance', 'amount']),
                },
                estandarDeReferencia: {
                    codigodeestandar: immCard.getIn(['criteria', 'c1', 'estand']),
                    subtipodeproducto: {
                        subtipodeproducto: immCard.getIn(['criteria', 'c1', 'subtipoproducto']),
                        tipodeproducto: {
                            tipodeproducto: immCard.getIn(['contract', 'product'])
                        }
                    }
                },
                tipoLiquidacion: immECardInfo.get('tipoLiquidacion'),
                formaDePago: immECardInfo.get('formaDePago'),
                nomTitular: immECardInfo.get('nomTitular'),
                descNomProdISBAN: immECardInfo.get('descNomProdISBAN')
            },
            importeOperacion: {
                divisa: immCard.getIn(['availableBalance', 'currency'])
            }
        }
    }
    return requestData;
}

const validateWithAPI = () => (dispatch, getState) => {
    const immCardCharge = getState().cardCharge.getIn(['steps', 0]);
    const valid = immCardCharge.get('valid');

    if (valid) {
        const cardId = immCardCharge.get('cardId');
        const accountId = immCardCharge.get('accountId');

        let requestData = baseRequestData(getState, cardId, accountId);
        requestData.query.importeOperacion.importe = immCardCharge.get('amount'),

        dispatch(validationRequest());
        let validationEndpoint = ( immCardCharge.get('operationType') === CARD_CHARGE_OPERATION_CHARGE ) ? 'eCardChargeValidation' : 'eCardDischargeValidation';
        const periodicityEnabled = immCardCharge.get('periodicityEnabled');
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const endDateValue = getEndDateForCardCharge(immCardCharge);

        if (immCardCharge.get('operationType') === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
            validationEndpoint = 'eCardChargePeriodicConfirmation';
            let scheduleType = toFirstUppercase(immCardCharge.get('periodicityRange'));
            if(scheduleType === toFirstUppercase(PERIODICITY_BIANNUAL)) {
                scheduleType = PERIODICITY_HALF_YEARLY;
            }

            requestData = {
                query: {
                    contractNumber: immAccount.get('contractNumber'),
                    endDate: endDateValue,
                    pan: immCard.getIn(['interventionList','0','pan']),
                    product: immAccount.get('product'),
                    scheduleType,
                    startDate: immCardCharge.get('date').format(DATE_FORMAT_API),
                    transferAmount: immCardCharge.get('amount')
                }
            };
        }
        return APIPost({
            dispatch,
            endpoint: validationEndpoint,
            params: requestData
        })
        .then((response) => dispatch(validationSuccess(response)))
        .catch((response) => dispatch(validationFailure(response.error)))
    }
}

const validateStep = step => (dispatch, getState) => {
    const immCardCharge = getState().cardCharge;
    const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
    const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
    dispatch(validateUIStep(step));
    if(!periodicityEnabled){
        dispatch(validateWithAPI());
    }
};

const sendReward = () => (dispatch, getState) => {
    const immCardCharge = getState().cardCharge;
    const immCards = getState().cards;
    const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
    const cardId = immCardChargeStep1.get('cardId');
    const immCard = immCards.getIn(['byId', cardId]);
    const panNumber = immCard.getIn(['interventionList', 0, 'pan']);
    const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
    if(!periodicityEnabled && immCardChargeStep1.get('cardType') === CARD_OPENYOUNG && immCardChargeStep1.get('operationType') === CARD_CHARGE_OPERATION_CHARGE) {
        const requestData = {
            query: {
                childDetail: {
                    contractNumber:  immCard.getIn(['contract', 'number']),
                    pan: panNumber && panNumber.substr(-4),
                    productCode: immCard.getIn(['contract', 'product'])
                },
                rewardDetail: {
                    rewardAmount: immCardChargeStep1.get('amount') || 0
                }
            }
        };
        return APIPost({
            dispatch,
            endpoint: 'openYoungSendReward',
            params: requestData
        });
    }
}

const editCardChargeView = (data) => (dispatch, getState) => {
    const immAccounts  = getState().accounts;
    const accountNumber = data.get('accountNumber');
    const product = accountNumber && accountNumber.substr(0,3);
    const contractNumber = accountNumber && accountNumber.substr(3);
    let accountId;
    immAccounts.get('byOrder').every((accountNo) => {
        const account = immAccounts.getIn(['byId', accountNo]);
        const isAccountPreset = (account.get('contractNumber') === contractNumber) && (account.get('product') === product);
        if(isAccountPreset){
            accountId = accountNo;
        }
        return !isAccountPreset;
    });
    const editInfo = {
        isEdit: true,
        editInfo: data
    };

    dispatch(editCardChargeStep1(editInfo));

    dispatch(setPeriodicityConcept(data.get('comment')));
    (accountId) && dispatch(setAccount(accountId));
    dispatch(setAmount(data.get('transferAmount')));
    dispatch(setOperationType(CARD_CHARGE_OPERATION_CHARGE));
    dispatch(handlePeriodicityEnabled(true));
    dispatch(setDate(moment(data.get('startDate'))));
    if(data.get('scheduleType') === PERIODICITY_HALF_YEARLY) {
        dispatch(handlePeriodicityRange(PERIODICITY_BIANNUAL));
    } else {
        dispatch(handlePeriodicityRange(data.get('scheduleType').toUpperCase()));
    }
    if(data.get('endDate')) {
        if(data.get('endDate') === DATE_FOR_INFINITE ) {
            dispatch(handlePeriodicityType(PERIODICITY_CONSTANTLY));
        } else {
            dispatch(handlePeriodicityType(PERIODICITY_DATE));
            dispatch(handlePeriodicityDate(moment(data.get('endDate'))));
        }
    }
}

const postChange = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardCharge = getState().cardCharge;
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        const accountId = immCardChargeStep1.get('accountId');
        const cardId = immCardChargeStep1.get('cardId');
        const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
        let requestData;

        if(!periodicityEnabled) {
            const liquidationData = immCardCharge.getIn(['extra', 'liquidationData']) && immCardCharge.getIn(['extra', 'liquidationData']).toJS();

            requestData = baseRequestData(getState, cardId, accountId);
            requestData.query.dataToken = dataToken;
            requestData.query.datosPreliq = liquidationData;
            requestData.query.importeOperacion.importe = immCardChargeStep1.get('amount');
        }

        dispatch(confirmationRequest());

        let confirmationEndpoint;
        confirmationEndpoint = ( immCardChargeStep1.get('operationType') === CARD_CHARGE_OPERATION_CHARGE ) ? 'eCardChargeConfirmation' : 'eCardDischargeConfirmation';
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const endDateValue = getEndDateForCardCharge(immCardChargeStep1);

        if(immCardChargeStep1.get('isEdit')){
            confirmationEndpoint = 'eCardChargeEditPeriodicConfirmation';
            let scheduleType = toFirstUppercase(immCardChargeStep1.get('periodicityRange'));
            if(scheduleType === toFirstUppercase(PERIODICITY_BIANNUAL)) {
                scheduleType = PERIODICITY_HALF_YEARLY;
            }

            requestData = {
                query: {
                    comment: immCardChargeStep1.get('periodicityConcept'),
                    contractNumber: immAccount.get('contractNumber'),
                    endDate: endDateValue,
                    product: immAccount.get('product'),
                    scheduleType,
                    scheduleTransferId: immCardChargeStep1.getIn(['editInfo','scheduleTransferId']),
                    startDate: immCardChargeStep1.get('date').format(DATE_FORMAT_API),
                    transferAmount: immCardChargeStep1.get('amount')
                }
            };
        } else if (immCardChargeStep1.get('operationType') === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
            confirmationEndpoint = 'eCardChargePeriodicConfirmation';
            let scheduleType = toFirstUppercase(immCardChargeStep1.get('periodicityRange'));
            if(scheduleType === toFirstUppercase(PERIODICITY_BIANNUAL)) {
                scheduleType = PERIODICITY_HALF_YEARLY;
            }
            requestData = {
                query: {
                    comment: immCardChargeStep1.get('periodicityConcept'),
                    contractNumber: immAccount.get('contractNumber'),
                    endDate: endDateValue,
                    pan: immCard.getIn(['interventionList','0','pan']),
                    product: immAccount.get('product'),
                    scheduleType,
                    startDate: immCardChargeStep1.get('date').format(DATE_FORMAT_API),
                    transferAmount: immCardChargeStep1.get('amount')
                }
            };
        }
        return APIPost({
            dispatch,
            endpoint: confirmationEndpoint,
            params: requestData
        })
        .then((response) => {
            dispatch(outdateGlobalPosition());
            dispatch(sendReward());
            return dispatch(confirmationSuccess(response));
        })
        .catch((response) => dispatch(confirmationFailure(response.error)))
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

const requestECardInfo = cardId => (dispatch)  => {
    dispatch(getECardInformation(cardId));
}

module.exports = {
    editCardChargeView,
    clearRequest,
    handlePeriodicityCount,
    handlePeriodicityDate,
    handlePeriodicityEnabled,
    handlePeriodicityConcept,
    handlePeriodicityRange,
    handlePeriodicityType,
    postChange,
    requestECardInfo,
    setAccount,
    setAllAccountsToInactive,
    setAmount,
    setDate,
    setOperationType,
    setView,
    setVisibleStep,
    withdrawTotalAmount,
    validateStep,
    setWillCancel,
    setTodayDate,
    baseRequestData,
    confirmationRequest,
    confirmationSuccess,
    confirmationFailure
}
